export enum enumPaymentMethodCodeId {
  STRIPE_ACH_CREDIT = 6,
  STRIPE_US_CREDIT_DEBIT_CARD = 2,
  STRIPE_ALIPAY = 5,
  PAYPAL = 1,
  STRIPE_ACH_DEBIT = 4,
  STRIPE_CREDIT_DEBIT_CARD = 9,
  BANK_TRANSFER = 7,
}
